import { render, staticRenderFns } from "./FAddress.vue?vue&type=template&id=c2bb3100&scoped=true"
import script from "./FAddress.vue?vue&type=script&lang=ts"
export * from "./FAddress.vue?vue&type=script&lang=ts"
import style0 from "./FAddress.vue?vue&type=style&index=0&id=c2bb3100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bb3100",
  null
  
)

export default component.exports